import { useEffect, useRef, useState, useCallback } from "react";
import { tns } from "tiny-slider/src/tiny-slider";

import "tiny-slider/dist/tiny-slider.css";
import { fetchAds } from "../services/adsService";
import "../assets/css/AdsSlider.css";

const AdsSlider = ({ placement }) => {
    const [ads, setAds] = useState([]);
    const sliderRef = useRef(null);
    const sliderInstance = useRef(null);
    const timeoutRef = useRef(null);
    const currentIndexRef = useRef(0);

    // FETCH ADS
    useEffect(() => {
        fetchAds(placement).then(data => {
            setAds(data);
        });
    }, [placement]);

    // CUSTOM AUTOPLAY
    const startCustomAutoplay = useCallback(() => {
        const runSlide = () => {
            const currentIndex = currentIndexRef.current;
            const currentAd = ads[currentIndex];

            // Dynamic timing from backend
            const slideTime = currentAd?.display_duration * 1000 || 5000;

            timeoutRef.current = setTimeout(() => {
                if (!sliderInstance.current) return;

                sliderInstance.current.goTo("next");

                // update index
                currentIndexRef.current =
                    (currentIndex + 1) % ads.length;

                runSlide();
            }, slideTime);
        };

        runSlide();
    }, [ads]);

    // INIT SLIDER
    useEffect(() => {
        if (ads.length === 0) return;

        sliderInstance.current = tns({
            container: sliderRef.current,
            items: 1,
            slideBy: 1,
            autoplay: false,
            controls: false,
            nav: false,
            gutter: 10,
            mouseDrag: true,
            loop: true,
        });

        startCustomAutoplay();

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            if (sliderInstance.current) {
                sliderInstance.current.destroy();
            }
        };
    }, [ads, startCustomAutoplay]);

    if (!ads.length) return null;

    return (
        <div className="ads-slider-wrapper container-fluid py-lg-4 py-3 px-0">
            <div ref={sliderRef}>
                {ads.map(ad => (
                    <div key={ad.id}>
                        <a
                            href={ad.target_url || "#"}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={ad.image_url}
                                alt={ad.title}
                                className="img-fluid rounded"
                            />

                            <h4 className="ads-heading">
                                {ad.title}
                            </h4>
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AdsSlider;
